enum StorageKey {
	REFRESH_TOKEN = 'refreshToken',
	REMEMBER = 'remember',
	USER = 'user',
	CONTENT = 'contents',
}

export default StorageKey;
